import { cn } from '@/lib/cn'

const DOT_DELAYS = ['0ms', '150ms', '300ms']

/**
 * The page and sign-in loader: the logo pulsing over three bouncing dots, the
 * same loader the event app uses. `tone` follows the background it sits on:
 * `light` for the storefront and the portal sheet, `dark` for screens on the
 * blue body (the sign-in check of the consoles, the job sheet). index.html
 * carries a static copy for the moment before React starts.
 */
export default function LogoLoader({
  label = 'Loading',
  tone = 'light',
  className,
}: {
  label?: string
  tone?: 'light' | 'dark'
  className?: string
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn('flex flex-col items-center justify-center py-24', className)}
    >
      <span className="sr-only">{label}</span>
      {/* alt is empty - the sr-only label already announces the status. */}
      <img
        src={tone === 'dark' ? '/logo_hd_white.png' : '/logo_hd.png'}
        alt=""
        className="h-8 w-auto animate-pulse object-contain motion-reduce:animate-none"
      />
      <div className="mt-4 flex gap-1.5" aria-hidden="true">
        {DOT_DELAYS.map((delay) => (
          <span
            key={delay}
            className={cn(
              'size-2 animate-bounce rounded-full motion-reduce:animate-none',
              tone === 'dark' ? 'bg-white' : 'bg-primary',
            )}
            style={{ animationDelay: delay }}
          />
        ))}
      </div>
    </div>
  )
}
